module.exports = __webpack_public_path__ + "7d817a8b668247cb239170467ea987a1.png";